// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"caadcc49","149":"02929a85","168":"c9e2a289","324":"cfafe16c","453":"a6a97343","536":"59f2ba14","544":"0130fa34","668":"8b4120a0","672":"b1086d55","814":"8d1a319b","846":"538d43eb","882":"6e911eb4","935":"286b27ef","994":"120c29f7"}[chunkId] + ".chunk.js";
};